export const FIGSHELF_INDEXEDDB_DATABASES = [
  'FigshelfWidgetsDB',
  'FigshelfFeedDB',
  'FigshelfDatabaseDB',
  'FigshelfMessagesDB',
  'FigshelfNotificationsDB',
];

const deleteIndexedDbDatabase = (name) => {
  return new Promise((resolve) => {
    try {
      const req = indexedDB.deleteDatabase(name);
      req.onsuccess = () => resolve(true);
      req.onerror = () => resolve(false);
      req.onblocked = () => resolve(false);
    } catch {
      resolve(false);
    }
  });
};

export const clearClientCache = async ({
  queryClient,
  clearServiceWorkerCaches = true,
  clearSessionStorage = true,
} = {}) => {
  // Clear in-memory React Query cache
  try {
    if (queryClient && typeof queryClient.clear === 'function') {
      queryClient.clear();
    }
  } catch {
  }

  // Clear user auth + user-specific localStorage
  try {
    localStorage.removeItem('@auth_token');
  } catch {
  }

  try {
    localStorage.removeItem('messages:lastConversationId');
  } catch {
  }

  // Clear session storage (usually user/session scoped)
  if (clearSessionStorage) {
    try {
      sessionStorage.clear();
    } catch {
    }
  }

  // Clear IndexedDB caches (Dexie-backed)
  try {
    await Promise.all(FIGSHELF_INDEXEDDB_DATABASES.map((n) => deleteIndexedDbDatabase(n)));
  } catch {
  }

  // Clear ServiceWorker CacheStorage (optional)
  if (clearServiceWorkerCaches && typeof caches !== 'undefined' && caches?.keys) {
    try {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    } catch {
    }
  }
};
